import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { EmployeePermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { ICatalogueProperties } from "mobx-stores/_models/base";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useState } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { XTextField } from "share-components/mui-wrap/text-field/x-text-field";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { AddEmployee } from "../add-employee/add-employee";
import { EmployeeTable } from "./employee-table";

export const EmployeeList = observer(() => {
  const {
    employeeManagement: { openNew, pagination, getEmployees, queryParams },
  } = useStores();
  const [departmentTypes, setDeparmentTypes] = useState<
    ICatalogueProperties[] | null
  >(null);
  const fetchDepartmentTypes = useCallback(async () => {
    if (departmentTypes != null) return;
    const res = await employeeBussiness.getDepartmentTypes();
    setDeparmentTypes(res.items || null);
  }, [departmentTypes]);
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getEmployees();
  }, [getEmployees, pagination]);

  useEffect(() => {
    fetchDepartmentTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageFilterContainer direction={"row"} spacing={1}>
        <XSearchTextField
          label="Mã nhân viên"
          value={queryParams.code}
          onChange={(e) => queryParams.setProp("code", e.currentTarget.value)}
        ></XSearchTextField>

        <XSearchTextField
          label="Tên nhân viên"
          sx={{ minWidth: "300px" }}
          value={queryParams.fullName}
          onChange={(e) =>
            queryParams.setProp("fullName", e.currentTarget.value)
          }
        ></XSearchTextField>

        <XTextField
          label="Bộ Phận"
          sx={{ minWidth: "250px" }}
          select
          value={queryParams.departmentTypeId}
          onChange={(e) => {
            queryParams.setProp("departmentTypeId", e.target?.value || null);
          }}
        >
          <MenuItem value={undefined}>
            <em>Tất cả</em>
          </MenuItem>
          {departmentTypes ? (
            departmentTypes.map((x) => (
              <MenuItem key={x.id} value={x.id}>
                {x.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem></MenuItem>
          )}
        </XTextField>
        <SearchButton asyncAction={onSearch}></SearchButton>
      </PageFilterContainer>
      <PageContentContainer>
        <EmployeeTable></EmployeeTable>
      </PageContentContainer>

      <>
        <>{openNew && <AddEmployee></AddEmployee>}</>
      </>
    </>
  );
});

const Header = observer(() => {
  const {
    employeeManagement: { setProp, queryParams, getEmployees },
  } = useStores();

  const showLeaveEmployeeHandler = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      queryParams.setProp("showInActive", checked);
      getEmployees();
    },
    [getEmployees, queryParams]
  );

  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Quản lý nhân viên</Typography>
      </Stack>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <FormControlLabel
          control={
            <Checkbox
              checked={queryParams.showInActive}
              onChange={showLeaveEmployeeHandler}
            />
          }
          label="Hiển thị cả NV thôi việc"
        />
        <Box>
          <AddButton
            accessPermission={[EmployeePermission.Create]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm mới
          </AddButton>
        </Box>
      </Stack>
    </>
  );
});
